// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
let MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
let MarkPropertyAsRentedDialog = require("../ClientPage/MarkPropertyAsRentedDialog.bs.js");
let MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
let RenewRentalPropertyMutation = require("../ClientPage/RenewRentalPropertyMutation.bs.js");
let OwnRentalPropertyStatusLabel = require("../OwnRentalPropertyStatusLabel.bs.js");
let WithdrawRentalPropertyDialog = require("../ClientPage/WithdrawRentalPropertyDialog.bs.js");
let MyClientsWidgetLandlord_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_landlord_graphql.bs.js");
let MyClientsWidgetLandlord_Menu_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_Menu_landlord_graphql.bs.js");
let MyClientsWidgetLandlord_name_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_name_landlord_graphql.bs.js");
let MyClientsWidgetLandlord_status_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_status_landlord_graphql.bs.js");
let MyClientsWidgetLandlord_rowDetails_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_rowDetails_landlord_graphql.bs.js");
let MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql = require("../../../__generated__/MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.bs.js");

let convertFragment = MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetLandlord$Menu$ActivityReportMenuItem(props) {
  let property = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property_graphql.node, convertFragment, props.property);
  let hasActivityReport = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(property.broadcasts, connection => connection.edges), [])).some(edge => {
    let match = edge.node.activityReport;
    return match.__typename === "ActivityReportV5";
  });
  if (hasActivityReport) {
    return JsxRuntime.jsx(MenuV5.MenuItem.make, {
      href: `/properties/` + property.id + `/report`,
      children: "View activity report"
    });
  } else {
    return null;
  }
}

let ActivityReportMenuItem = {
  PropertyFragment: PropertyFragment,
  make: MyClientsWidgetLandlord$Menu$ActivityReportMenuItem
};

let convertFragment$1 = MyClientsWidgetLandlord_Menu_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment$1, fRef);
}

let LandlordFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetLandlord$Menu(props) {
  let landlord = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment$1, props.landlord);
  let match = landlord.property.status;
  let isArchived;
  switch (match.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
      isArchived = false;
      break;
    default:
      isArchived = match.archived;
  }
  let match$1 = React.useState(() => false);
  let setDeleteDialogOpen = match$1[1];
  let match$2 = SystemMessages.useSystemMessages();
  let addMessage = match$2.addMessage;
  let handleRenewingError = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the property active. Please try again...", 5000, undefined, undefined));
  let match$3 = RenewRentalPropertyMutation.use(landlord.property.id, landlord.property.nodeId, handleRenewingError, false);
  let makePropertyActiveIsLoading = match$3[1];
  let makePropertyActive = match$3[0];
  let match$4 = React.useState(() => false);
  let setWithdrawDialogOpened = match$4[1];
  let match$5 = React.useState(() => false);
  let setMarkAsRentedDialogOpened = match$5[1];
  let match$6 = landlord.property.status;
  let submenuName;
  switch (match$6.__typename) {
    case "ActiveProperty" :
      submenuName = match$6.isRenewable ? "Renew or change status" : "Change status";
      break;
    case "ExpiredProperty" :
      submenuName = "Renew or change status";
      break;
    default:
      submenuName = "Change status";
  }
  let tmp;
  if (isArchived) {
    tmp = JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
      name: submenuName,
      unavailableReason: "The property has been archived",
      unavailableDescription: "Archived properties cannot be renewed or have their status changed."
    });
  } else {
    let match$7 = landlord.property.status;
    let tmp$1;
    let exit = 0;
    switch (match$7.__typename) {
      case "ActiveProperty" :
        if (match$7.isRenewable) {
          exit = 1;
        } else {
          tmp$1 = null;
        }
        break;
      case "ExpiredProperty" :
        exit = 1;
        break;
      default:
        tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: () => {
            makePropertyActive();
          },
          isDisabled: makePropertyActiveIsLoading,
          children: "Change to active"
        });
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => {
          makePropertyActive();
        },
        isDisabled: makePropertyActiveIsLoading,
        children: "Renew property"
      });
    }
    let match$8 = landlord.property.status;
    let tmp$2;
    tmp$2 = match$8.__typename === "RentedProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => setMarkAsRentedDialogOpened(param => true),
        children: "Mark as rented"
      });
    let match$9 = landlord.property.status;
    let tmp$3;
    tmp$3 = match$9.__typename === "WithdrawnProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => setWithdrawDialogOpened(param => true),
        children: "Withdraw property"
      });
    tmp = JsxRuntime.jsxs(MenuV5.Submenu.make, {
      name: submenuName,
      children: [
        tmp$1,
        tmp$2,
        tmp$3
      ]
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(WithdrawRentalPropertyDialog.make, {
        propertyId: landlord.property.id,
        isOpen: match$4[0],
        close: () => setWithdrawDialogOpened(param => false)
      }),
      JsxRuntime.jsx(MarkPropertyAsRentedDialog.make, {
        propertyId: landlord.property.id,
        isOpen: match$5[0],
        close: () => setMarkAsRentedDialogOpened(param => false)
      }),
      JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
        client: landlord.fragmentRefs,
        isOpen: match$1[0],
        onCancel: () => setDeleteDialogOpen(param => false),
        onSuccess: () => setDeleteDialogOpen(param => false),
        connectionId: props.connectionId
      }),
      JsxRuntime.jsxs(MenuV5.Menu.make, {
        button: JsxRuntime.jsx(ButtonsV5.Button.make, {
          className: "!border-none",
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            size: 16,
            className: "text-black"
          })
        }),
        children: [
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: "Edit rental property",
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be edited."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/properties/` + landlord.property.id + `/edit`,
              children: "Edit rental property"
            }),
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: "Broadcast property",
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be broadcasted."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/properties/` + landlord.property.id + `/broadcast`,
              children: "Broadcast property"
            }),
          tmp,
          JsxRuntime.jsx(React.Suspense, {
            children: JsxRuntime.jsx(MyClientsWidgetLandlord$Menu$ActivityReportMenuItem, {
              property: landlord.property.fragmentRefs
            }),
            fallback: null
          }),
          isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
              name: "Delete landlord",
              unavailableReason: "The property has been archived",
              unavailableDescription: "Archived properties cannot be deleted."
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: () => setDeleteDialogOpen(param => true),
              children: "Delete landlord"
            })
        ]
      })
    ]
  });
}

let Menu = {
  ActivityReportMenuItem: ActivityReportMenuItem,
  LandlordFragment: LandlordFragment,
  make: MyClientsWidgetLandlord$Menu
};

let convertFragment$2 = MyClientsWidgetLandlord_status_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$2, fRef);
}

let LandlordFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetLandlord$Status$WithoutErrorBoundary(props) {
  let landlord = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$2, props.landlord);
  return JsxRuntime.jsx(OwnRentalPropertyStatusLabel.make, {
    rentalProperty: landlord.property.fragmentRefs
  });
}

let WithoutErrorBoundary = {
  RentalPropertyStatusLabel: undefined,
  LandlordFragment: LandlordFragment$1,
  make: MyClientsWidgetLandlord$Status$WithoutErrorBoundary
};

function MyClientsWidgetLandlord$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "landlord status",
    children: JsxRuntime.jsx(MyClientsWidgetLandlord$Status$WithoutErrorBoundary, {
      landlord: props.landlord
    })
  });
}

let Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetLandlord$Status
};

let convertFragment$3 = MyClientsWidgetLandlord_name_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$3, fRef);
}

let LandlordFragment_rentalPropertyMatchingType_decode = MyClientsWidgetLandlord_name_landlord_graphql.Utils.rentalPropertyMatchingType_decode;

let LandlordFragment_rentalPropertyMatchingType_fromString = MyClientsWidgetLandlord_name_landlord_graphql.Utils.rentalPropertyMatchingType_fromString;

let LandlordFragment$2 = {
  rentalPropertyMatchingType_decode: LandlordFragment_rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: LandlordFragment_rentalPropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetLandlord$Name(props) {
  let landlord = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$3, props.landlord);
  let match = landlord.property.propertyLocation;
  let address;
  if (match !== undefined) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        address = match.locationDisplay;
        break;
      case "PropertyLocationWithVisibleAddress" :
        address = match.address;
        break;
      case "__unselected" :
        address = undefined;
        break;
    }
  } else {
    address = undefined;
  }
  let supportingText = Stdlib_Option.getOr(Stdlib_Option.map(address, address => JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("span", {
        children: address
      }),
      JsxRuntime.jsx("span", {
        children: "•",
        className: "text-gray-400"
      })
    ]
  })), null);
  let match$1 = landlord.property.propertyLocation;
  let tmp;
  if (match$1 !== undefined) {
    switch (match$1.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = JsxRuntime.jsx(MyClientsWidgetComponents.HiddenAddressIcon.make, {});
        break;
      case "PropertyLocationWithVisibleAddress" :
      case "__unselected" :
        tmp = null;
        break;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Rental property",
            className: "text-gray-500 text-sm font-semibold uppercase tracking-wide"
          }),
          tmp
        ],
        className: "flex gap-2 items-center"
      }),
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `my_clients/` + landlord.id,
        children: JsxRuntime.jsx("div", {
          children: landlord.displayName,
          className: "text-lg font-medium"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          supportingText,
          JsxRuntime.jsx(PropertyPrice.make, {
            property: landlord.property.fragmentRefs,
            size: "small",
            className: "!text-base sm:!text-base !font-normal !text-gray-500"
          })
        ],
        className: "text-base text-gray-500 flex flex-wrap items-center gap-x-1"
      })
    ],
    className: "flex flex-col gap-1"
  });
}

let Name = {
  LandlordFragment: LandlordFragment$2,
  make: MyClientsWidgetLandlord$Name
};

let convertFragment$4 = MyClientsWidgetLandlord_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$4, fRef);
}

let LandlordFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let convertFragment$5 = MyClientsWidgetLandlord_rowDetails_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_rowDetails_landlord_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_rowDetails_landlord_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_rowDetails_landlord_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_rowDetails_landlord_graphql.node, convertFragment$5, fRef);
}

let LandlordFragment$4 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function MyClientsWidgetLandlord$RowDetails(props) {
  let rowDetails = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_rowDetails_landlord_graphql.node, convertFragment$5, props.landlord);
  let match = rowDetails.property.status;
  let isArchived;
  switch (match.__typename) {
    case "ActiveProperty" :
    case "RemovedProperty" :
    case "__unselected" :
      isArchived = false;
      break;
    default:
      isArchived = match.archived;
  }
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
    name: props.name,
    status: props.status,
    matches: JsxRuntime.jsx(MyClientsWidgetComponents.MatchesSummary.make, {
      matchable: rowDetails.property.fragmentRefs,
      clientId: rowDetails.id
    }),
    menu: props.menu,
    dim: isArchived
  });
}

let RowDetails = {
  LandlordFragment: LandlordFragment$4,
  make: MyClientsWidgetLandlord$RowDetails
};

function MyClientsWidgetLandlord(props) {
  let landlord = RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$4, props.landlord);
  return JsxRuntime.jsx(MyClientsWidgetLandlord$RowDetails, {
    landlord: landlord.fragmentRefs,
    name: JsxRuntime.jsx(MyClientsWidgetLandlord$Name, {
      landlord: landlord.fragmentRefs
    }),
    status: JsxRuntime.jsx(MyClientsWidgetLandlord$Status, {
      landlord: landlord.fragmentRefs
    }),
    menu: JsxRuntime.jsx(MyClientsWidgetLandlord$Menu, {
      landlord: landlord.fragmentRefs,
      connectionId: props.connectionId
    })
  });
}

let Components;

let Link;

let DeleteDialog;

let make = MyClientsWidgetLandlord;

exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Status = Status;
exports.Name = Name;
exports.LandlordFragment = LandlordFragment$3;
exports.RowDetails = RowDetails;
exports.make = make;
/* react Not a pure module */
